module.exports = __webpack_public_path__ + "media/images/banner-cf@3x-8e4c4a7ff9b235e5eaa12e51030188a6.png";